import React from 'react';
import type { VendorBasicInfo } from '../types';

interface Props {
  data: VendorBasicInfo | null;
}

export default function VendorInfoTab({ data }: Props) {
  if (!data) return <div className="p-8 text-center text-gray-500">정보가 없습니다.</div>;

  return (
    <div className="space-y-6">
      {/* 사업자 정보 */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">사업자 정보</h3>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">사업자등록번호</label>
            <p className="text-gray-900">{data.businessNumber}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">등록일</label>
            <p className="text-gray-900">{data.regDate}</p>
          </div>
          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">사업장 주소</label>
            <p className="text-gray-900">{data.address}</p>
          </div>
        </div>
      </div>

      {/* 계좌 정보 */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">계좌 정보</h3>
        <div className="grid grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">은행명</label>
            <p className="text-gray-900">{data.bankName}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">계좌번호</label>
            <p className="text-gray-900">{data.accountNumber}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">예금주</label>
            <p className="text-gray-900">{data.accountHolder}</p>
          </div>
        </div>
      </div>

      {/* 메모 */}
      {data.memo && (
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">메모</h3>
          <p className="text-gray-700 bg-gray-50 rounded-lg p-4">{data.memo}</p>
        </div>
      )}
    </div>
  );
}